module.exports = __webpack_public_path__ + "static/media/notificationsFlatlineMobile.cd6641a7.png";